module.exports = __webpack_public_path__ + "img/195.fixed_water_bar.2ad93ddd.svg";